
<template>
  <v-container class="ma-0 pa-0">
    <v-row v-if="showHeader && prizes && prizes.length > 0">
      <v-col class="pt-0">{{$t('prizeSummaryWidget.title')}}</v-col>
    </v-row>
    <v-row v-for="placePrizes in places" :key="placePrizes.place" no-gutters class="pl-2">
      <v-col cols="12">
        <place-prizes-widget :place="placePrizes.place" :prizes="placePrizes.prizes"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PlacePrizesWidget from './PlacePrizesWidget.vue';

export default {
  name: "PrizesSummaryWidget",
  components: {
    PlacePrizesWidget,
  },
  props: {
    prizes: {
      type: Array,
      required: true,
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    places() {
      var ret = []
      if (!this.prizes) {
        return ret;
      }
      this.prizes.forEach((prize) => {
        var placePrizes = ret.find((placePrize) => placePrize.place == prize.place)
        if (placePrizes === undefined) {
          placePrizes = {place: prize.place, prizes: []}
          ret.push(placePrizes)
        }
        placePrizes.prizes.push(prize) 
      })
      ret = ret.sort((a, b) => a.place - b.place)
      return ret;
    }
  }
};
</script>